import axios from '@/plugins/axios'

export function getWorkers(params = {}) {
  return axios.get('worker', {
    params,
  })
}
export function getWorkOrderChart(params = {}) {
  return axios.get('worker/workOrderChart', {
    params,
  })
}

export function storeWorker(data) {
  return axios.post('worker', data)
}

export function updateWorker(id, data) {
  return axios.put(`worker/${id}`, data)
}

export function resetWorker(data) {
  return axios.post('worker/reset', data)
}


export function getWorkerRoles(params = {}) {
    return axios.get('worker/roles', {
        params,
    })
}
